/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AclBuildModel } from '../models/AclBuildModel';
import type { AutomotiveRequestMethod } from '../models/AutomotiveRequestMethod';
import type { BranchType } from '../models/BranchType';
import type { GetEnquiryResponse } from '../models/GetEnquiryResponse';
import type { UserStatusResponse } from '../models/UserStatusResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AclService {

  /**
   * @param dealId 
   * @returns AclBuildModel Success
   * @throws ApiError
   */
  public static getAclDeals(
dealId: number,
): CancelablePromise<AclBuildModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/acl/deals/{dealId}',
      path: {
        'dealId': dealId,
      },
    });
  }

  /**
   * @returns UserStatusResponse Success
   * @throws ApiError
   */
  public static getAclUsersStatus(): CancelablePromise<UserStatusResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/acl/users/status',
    });
  }

  /**
   * @param requestId 
   * @returns any Success
   * @throws ApiError
   */
  public static getAclRequests(
requestId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/acl/requests/{requestId}',
      path: {
        'requestId': requestId,
      },
    });
  }

  /**
   * @param enquiryId 
   * @param requestMethod
 *
 * 1 = CreateEnquiry
 *
 * 2 = GetEnquiry
 *
 * 3 = GetQuestions
 *
 * 4 = UpdateQuestions
 *
 * 5 = GetRecoms
 *
 * 6 = UpdateRecoms
 *
 * 7 = SendSms
 *
 * 8 = ConfirmSms
 *
 * 9 = UpdateHandover
 *
 * 10 = GetHandover
 *
 * 11 = GetUserStatus
   * @param json 
   * @param overridenBranchId
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @returns number Created
   * @throws ApiError
   */
  public static postAclRequests(
enquiryId?: number,
requestMethod?: AutomotiveRequestMethod,
json?: string,
overridenBranchId?: BranchType,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/acl/requests',
      query: {
        'enquiryId': enquiryId,
        'requestMethod': requestMethod,
        'json': json,
        'overridenBranchId': overridenBranchId,
      },
    });
  }

  /**
   * @param dealId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postAclEnquiries(
dealId?: number,
requestBody?: GetEnquiryResponse,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/acl/enquiries',
      query: {
        'dealId': dealId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

}
